import { Proposal } from "../types/Proposal";
import { PartialRecord } from "../types/GeneralTypes";

export const KorterConverter:PartialRecord<keyof Proposal, (input:any) => unknown> = {
    link: (link:string) => {
        return "https://korter.ge" + link;
    },
    type: (type: string) => {
        // Types are normalized to standard format by the backend (TypeUtils.convert)
        // before being stored. Raw korter values ('1','2','3','Studio') no longer
        // reach the frontend — pass through as-is.
        switch (type) {
            case 'Studio':
                return 'STUDIO';
            case '1':
                return 'ONE_ONE';
            case '2':
                return '2_BEDROOM';
            case '3':
            case '4+':
                return '3_BEDROOM';
            default:
                return type;
        }
    }
}
